export const IdConnectEvents = {
  onIdsAvailable: {
    name: 'onIdsAvailable',
    fieldsTemplate: [
      { key: 'mtid', isOptional: true, type: 'string' },
      { key: 'atid', isOptional: true, type: 'string' },
      { key: 'attrid', isOptional: true, type: 'string' },
      { key: 'category', isOptional: false, type: 'string' },
      { key: 'domain', isOptional: false, type: 'string' },
      { key: 'ttl', isOptional: false, type: 'string' },
      { key: 'entries', isOptional: false, type: 'array' },
    ],
  },
};

let wasOnFlowCompletedCalled = false;

export const UtiqEvents = {
  ...IdConnectEvents,
  onConsentUpdateFinished: {
    name: 'onConsentUpdateFinished',
    fieldsTemplate: [
      { key: 'isConsentGranted', isOptional: false, type: 'boolean' },
    ],
  },
  onConsentChanging: {
    name: 'onConsentChanging',
    fieldsTemplate: [
      { key: 'isConsentGranted', isOptional: false, type: 'boolean' },
    ],
  },
  onInitialised: {
    name: 'onInitialised',
    fieldsTemplate: [],
  },
  onEligibilityChecked: {
    name: 'onEligibilityChecked',
    fieldsTemplate: [{ key: 'isEligible', isOptional: false, type: 'boolean' }],
  },
  onDidomiConsentChanged: {
    name: 'onDidomiConsentChanged',
    fieldsTemplate: [],
  },
  onConsentManagerStatusChanged: {
    name: 'onConsentManagerStatusChanged',
    fieldsTemplate: [{ key: 'status', isOptional: false, type: 'string' }],
  },
  onFlowCompleted: {
    name: 'onFlowCompleted',
    fieldsTemplate: [{ key: 'status', isOptional: true, type: 'string' }],
    wasCalledAlready: () => {
      if (wasOnFlowCompletedCalled === false) {
        wasOnFlowCompletedCalled = true;
        return false;
      }
      return true;
    },
  },
};
